"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useToast", {
    enumerable: true,
    get: function() {
        return useToast;
    }
});
const _react = require("react");
const _ToastContext = require("../components/Toast/ToastContext");
const useToast = ()=>{
    return (0, _react.useContext)(_ToastContext.ToastContext);
};

//# sourceMappingURL=useToast.js.map